import React, { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Box,
  TextField,
  Button,
  IconButton,
  ButtonGroup,
  CircularProgress,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { apiRemote } from "@/api/wp-api";
import { ChevronDown } from "lucide-react";
import { MenuItem, Menu } from "@mui/material";
import SplitButton from "@/components/SplitButton";
import DttTableData from "@/components/DttTableData";
import ListingTableTemplate from "@/components/ListingTableTemplate";
import { WidthFull } from "@mui/icons-material";
import { useAlert } from "@/contexts/AlertContext";
import { useNavigate, Link, useParams } from "react-router";
import { StyledLink } from "@/components/StyledLink";
import DashboardMetrics from "./Dashboard-Metrics";
import LeaderboardRank from "./LeaderboardRank";
import BadgesSection from "./Badge-Section";
import IndonesiaCompetitonCourses from "./IndonesiaCompetitonCourses";
import MyCourses from "./My-Course";
import MyContest from "./My-Contest";
import OrtherCourseContest from "./OrtherCourseContest";
import { useDashboardContext } from "./Layout";
import { useUser } from "@/contexts/UserContext";

interface DashboardData {
  currentRankLeaderboard: any;
  infomationUser: any;
}

const DashboardGrid = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(4);
  const navigate = useNavigate();
  const [data, setData] = useState<DashboardData | null>(null);
  const { getDashBoard } = useDashboardContext();
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const { user, isIndo } = useUser();
  useEffect(() => {
    const fetchDashboard = async () => {
      setLoading(true); // Bắt đầu tải dữ liệu
      try {
        const res = await getDashBoard();
        setData(res);
      } catch (error) {
        console.error("Error fetching dashboard:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, []);

  return (
    <>
      {loading ? (
        <Box
          sx={{
            p: 3,
            bgcolor: "white",
            borderRadius: 2,
            boxShadow: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <DashboardMetrics initialData={data?.infomationUser} />
        </>
      )}
      <Box sx={{ display: "flex", gap: 2, mt: 2, flexDirection: { xs: "column", md: "row" }, }}>
        <LeaderboardRank 
          initialData={data?.currentRankLeaderboard} 
          sx={{ width: '30%', minWidth: '250px' }} 
        />
        <BadgesSection 
          sx={{ 
            flex: 1,
            '& .badge-item': {
              width: '250px',
              minWidth: '250px',
              maxWidth: '250px'
            }
          }} 
        />
      </Box>
      {isIndo && (
        <IndonesiaCompetitonCourses />
      )}
      {/* <IndonesiaCompetitonCourses /> */}
      <MyCourses />
      <MyContest />
      <OrtherCourseContest />
    </>
  );
};

export default DashboardGrid;
